import { useFeature, type FeatureState } from '@front/model'
import { useFeatureWithOverride } from './useFeatureWithOverride'

export const useWorkflowHidePreviousActivityFeature = (): FeatureState => {
  return useFeatureWithOverride({ featureId: 'Feature:WorkflowHidePreviousActivity' })
}

export const useWorkflowPreActionsFeature = (): FeatureState => {
  return useFeatureWithOverride({ featureId: 'Feature:WorkflowPreActions' })
}

export const useWorkflowSetterCloserConfigFeature = (): FeatureState => {
  return useFeatureWithOverride({ featureId: 'Feature:WorkflowSetterCloserConfig' })
}

export const useCalendarStackIdenticalEventsFeature = (): FeatureState => {
  return useFeatureWithOverride({ featureId: 'Feature:CalendarStackIdenticalEvents' })
}

export const useTeamHierarchyFocusViewFeature = (): FeatureState => {
  return useFeatureWithOverride({ featureId: 'Feature:TeamHierarchyFocusView' })
}

export const useNewLocationMatchFeature = (): FeatureState => {
  return useFeatureWithOverride({ featureId: 'Feature:NewLocationMatch' })
}

export const useCustomLocationManagementFeature = (): FeatureState => {
  return useFeatureWithOverride({ featureId: 'Feature:CustomLocationManagement' })
}

export const useConnectFeature = (): FeatureState => {
  return useFeature({ featureId: 'Feature:Connect' })
}

export const useTerrosMcpFeature = (): FeatureState => {
  return useFeature({ featureId: 'Feature:TerrosMCP', placeholder: false })
}

export const useAccountExportAuditFieldsFeature = (): FeatureState => {
  return useFeatureWithOverride({ featureId: 'Feature:AccountExportAuditFields', placeholder: false })
}
